module.exports = __webpack_public_path__ + "static/img/10.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/sp/10.png
// module id = /FjO
// module chunks = 0